<template>
    <div>
        <div v-if="src" class="flex flex-col">
            <div class="flex items-center justify-center overflow-hidden"
                :class="image_class"
            >
                <a v-if="include_link" :href="src" target="_blank">
                    <img class="object-cover w-full h-full" :src="src" />
                </a>

                <img v-else class="object-cover w-full h-full" :src="src" />
            </div>

            <div v-if="! read_only"
                class="cursor-pointer text-blue-400 hover:text-blue-300 mt-3"
                @click="deleteImage"
            >
                <i class="far fa-times-circle text-base mr-1"></i>
                Remove Image
            </div>
        </div>

        <div v-else-if="saving" class="flex items-center text-blue-600">
            <Spinner class="w-7 h-7 mr-3" />

            Uploading image ...
        </div>

        <div v-else>
            <input type="file"
                class="invisible w-0 h-0"
                ref="chooseFileButton"
                name="image"
                @change="onFileChange"
            >

            <div v-show="preview"
                class="flex items-center justify-center overflow-hidden"
                :class="image_class"
            >
                <img class="object-cover w-full h-full" :src="preview" />
            </div>

            <button v-if="store_url && ! read_only"
                type="button"
                class="bg-blue-400 hover:bg-blue-300 text-white uppercase text-xs px-6 py-3 tracking-wider cursor-pointer -ml-1"
                @click="selectImage"
                v-html="label || 'Select An Image'"
            >
            </button>
        </div>
    </div>
</template>

<script>
import Spinner from '../components/spinner.vue';

export default {
    components: {
        Spinner,
    },

    props: {
        image_url: {},
        image_object: {},
        store_url: {},
        delete_url: {},
        image_class: {},
        read_only: { default: false },
        returns_object: { default: false },
        include_link: { default: false },
        label: {},
    },

    data() {
        return {
            image: null,
            preview: null,
            src: this.image_object ? this.image_object.url : this.image_url,
            delete_url_proxy: this.delete_url,
            saving: false,
        }
    },

    methods: {
        onFileChange(event) {
            this.image = event.target.files[0];

            if (this.image && /\.(jpe?g|png)$/i.test(this.image.name)) {
                this.saveImage();
            } else {
                window.alert('Please select a JPEG or PNG file.');
            }
        },
        selectImage() {
            this.$refs.chooseFileButton.click();
        },
        saveImage(){
            let formData = new FormData();
            formData.append('image', this.image);
            this.saving = true;

            axios.post(this.store_url, formData)
                .then(response => {
                    this.saving = false;
                    this.src = this.returns_object ? response.data.url : response.data;
                    this.$emit('created', this.returns_object ? response.data : response.data.url);

                    if (response.data?.delete_url) {
                        this.delete_url_proxy = response.data.delete_url;
                    };
                })
                .catch(error => {
                    this.saving = false;
                    console.log(error);

                    if (error.response?.data?.message) {
                        alert(error.response.data.message);
                    }
                });
        },
        deleteImage(){
            axios.delete(this.delete_url_proxy)
                .then(response => {
                    this.src = null;
                    this.image = null;
                    this.preview = null;
                    this.$emit('deleted', { key: this.image_object?.key, id: this.image_object?.id });
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },
}
</script>
